import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {RestApi} from '../RestApi/restApi';
import {Router} from '@angular/router';
interface TemplateReportInfo {
  statusMessage: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class TemplateReportService {
  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi,
    private router: Router
  ) { }

  retrieveVaultBinderTemplatesCollection(){
    return this.http.get<TemplateReportInfo>(this.restAPI.RETRIEVEVAULTBINDERTEMPLATESCOLLECTION , {headers: this.headers});
  }

  insertUpdateReportTemplate(obj){
    return this.http.post<TemplateReportInfo>(this.restAPI.INSERTUPDATEREPORTTEMPLATE , JSON.stringify(obj),{headers: this.headers});

  }

  retrieveVaultBinderTemplateSections(dnsId,vaultBinderTemplateReference){
    return this.http.get<TemplateReportInfo>(this.restAPI.RETRIEVEVAULTBINDERTEMPLATESECTIONS+"/"+dnsId+"/"+vaultBinderTemplateReference , {headers: this.headers});
  }
  retrieveReportTemplatesByDnsId() {

    return this.http.get<TemplateReportInfo>(this.restAPI.RETRIEVEREPORTTEMPLATESBYDNSID, { headers: this.headers })

  }
  deleteReportTemplateById(templateId) {

    return this.http.delete<TemplateReportInfo>(this.restAPI.DELETEREPORTTEMPLATEBYID+"/"+templateId, { headers: this.headers })

  }
  retrieveAllVaultDocumentTypes() {

    return this.http.get<TemplateReportInfo>(this.restAPI.RETRIEVEALLVAULTDOCUMENTTYPES, { headers: this.headers })

  }
   retrieveVaultDocumentSubTypes(doctype) {

    return this.http.get<TemplateReportInfo>(this.restAPI.RETRIEVEVAULTDOCUMENTSUBTYPES+"/"+doctype, { headers: this.headers })

  }

  
   retrieveVaultDocumentClassifications(docType,docSubType) {

  return   this.http.get<TemplateReportInfo>(this.restAPI.RETRIEVEVAULTDOCUMENTCLASSIFICATIONS+"/"+docType+"/"+docSubType, { headers: this.headers })

  }
  retrieveVaultDocumentLifeCycleForClassifications(docType, docSubType,docClassfication) {

    return this.http.get<TemplateReportInfo>(this.restAPI.RETRIEVEVAULTDOCUMENTLIFECYCLEFORCLASSIFICATIONS + "/" + docType + "/" + docSubType + "/" + docClassfication, { headers: this.headers })

  }

 
  adhocReport(reportTemplateId,scheduleId){
    return this.http.get<TemplateReportInfo>(this.restAPI.ADHOC_REPORT+"/"+reportTemplateId+"/"+scheduleId,{ headers: this.headers })
  }

  retrieveReportInstances(reportTempId,reportName){
    return this.http.post<TemplateReportInfo>(this.restAPI.REPORT_INSTANCE+"/"+reportTempId+"/"+reportName,{ headers: this.headers })
    }

    retrieveDataset(datasetId,dnsId){
      return this.http.get<TemplateReportInfo>(this.restAPI.RETRIEVE_DATASET+"/"+datasetId+"/"+dnsId,{ headers: this.headers });
    }
    updateFilters(value){
    
      return this.http.post<TemplateReportInfo>(this.restAPI.UPDATE_FILTERS_LIST,JSON.stringify(value), { headers: this.headers })
    }
}
